import { useState } from 'react';

import AppBarSpacer from '../components/common/AppBarSpacer';
import MiniDrawer from '../components/MiniDrawer';
import PageHeader from '../components/common/PageHeader';
import CustomerIntakeResponsesOverview from '../components/CustomerIntake/CustomerIntakeResponsesOverview';
import { useTranslation } from '../i18n';

const CustomerSurveyResponses = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  return (
    <div className="flex h-screen">
      <MiniDrawer open={open} setOpen={setOpen} />
      <main className="flex-1 overflow-auto app-page-bg">
        <AppBarSpacer />
        <div className="h-full px-6 py-4">
          <PageHeader
            title={t('surveyResponses.pageTitle')}
            subtitle={t('surveyResponses.pageSubtitle')}
          />
          <CustomerIntakeResponsesOverview />
        </div>
      </main>
    </div>
  );
};

export default CustomerSurveyResponses;
